import G6 from '@antv/g6';

//基础矩形
const nodeBasicMethod = {
    createNodeBox: (group, cfg, w, h) => {
        let originColor1 = cfg.isOrigin ?
            {
                stroke: '#37CB64',
                fill: '#F9FFFB',
                shadowOffsetX: 2,
                shadowOffsetY: 2,
                shadowColor: '#93C4B6',
                shadowBlur: 10,

            } : {}
        let originColor2 = cfg.isOrigin ?
            { fill: '#37CB64' } : {}
        /* 最外面的大矩形 */
        const container = group.addShape('rect', {
            attrs: {
                x: -80,
                y: -30,
                width: w,
                height: h,
                fill: '#fff',
                stroke: '#B7C8D9',
                radius: 4,
                cursor: 'pointer',
                ...originColor1,
            },
            name: 'big-rect-shape',
            draggable: true,
        });

        /* 左边的粗线 */
        group.addShape('rect', {
            attrs: {
                x: -80,
                y: -30,
                width: 5,
                height: h,
                fill: '#0073E1',
                radius: [4, 0, 0, 4],
                ...originColor2,
            },
            name: 'left-border-shape',
            draggable: true,
        });

        return container;
    },
}

const blueNomal = (shape1, shape2) => {
    shape1.attr('stroke', '#B7C8D9');
    shape1.attr('shadowOffsetX', 0);
    shape1.attr('shadowOffsetY', 0);
    shape1.attr('shadowBlur', 0);
    shape2.attr('stroke', '#0073E1');

}
const blueHover = (shape1, shape2) => {
    shape1.attr('stroke', '#0073E1');
    shape1.attr('shadowOffsetX', 1);
    shape1.attr('shadowOffsetY', 1);
    shape1.attr('shadowColor', '#83D7F3');
    shape1.attr('shadowBlur', 5);
    shape2.attr('stroke', '#0073E1');
}
const blueSelect = (shape1, shape2) => {
    shape1.attr('stroke', '#0073E1');
    shape1.attr('shadowOffsetX', 5);
    shape1.attr('shadowOffsetY', 2);
    shape1.attr('shadowColor', '#83D7F3');
    shape1.attr('shadowBlur', 10);
    shape2.attr('stroke', '#0073E1');
}
const greenNomal = (shape1, shape2) => {
    shape1.attr('stroke', '#37CB64');
    shape1.attr('shadowOffsetX', 0);
    shape1.attr('shadowOffsetY', 0);
    shape1.attr('shadowBlur', 0);
    shape2.attr('stroke', '#37CB64');
}
const greenHover = (shape1, shape2) => {
    shape1.attr('stroke', '#37CB64');
    shape1.attr('shadowOffsetX', 1);
    shape1.attr('shadowOffsetY', 1);
    shape1.attr('shadowColor', '#37CB64');
    shape1.attr('shadowBlur', 5);
    shape2.attr('stroke', '#37CB64');
}
const greenSelect = (shape1, shape2) => {
    shape1.attr('stroke', '#37CB64');
    shape1.attr('shadowOffsetX', 5);
    shape1.attr('shadowOffsetY', 2);
    shape1.attr('shadowColor', '#37CB64');
    shape1.attr('shadowBlur', 10);
    shape2.attr('stroke', '#37CB64');
}

function renderShape() {
    G6.registerNode('card-node', {
        // options: {
        //     style: {},
        //     stateStyles: {
        //         hover: {fill:'#aaa'},
        //         selected: {fill:'#3a3'},
        //     },
        // },
        setState(name, value, item) {
            const group = item.getContainer();
            const shape1 = group.get('children')[0]; // 顺序根据 draw 时确定
            const shape2 = group.get('children')[1];
            if (item._cfg.model.isOrigin) {
                if (name === 'hover') {
                    if (value === true) {
                        greenHover(shape1, shape2)
                    } else {
                        if (item._cfg.states.includes('selected')) {
                            greenSelect(shape1, shape2)
                        } else {
                            greenNomal(shape1, shape2)
                        }

                    }
                } else if (item._cfg.states.includes('selected')) {
                    greenSelect(shape1, shape2)
                } else {
                    greenNomal(shape1, shape2)
                }
            } else {
                if (name === 'hover') {
                    if (value === true) {
                        blueHover(shape1, shape2)

                    } else {
                        if (item._cfg.states.includes('selected')) {
                            blueSelect(shape1, shape2)
                        } else {
                            blueNomal(shape1, shape2)
                        }

                    }
                } else if (item._cfg.states.includes('selected')) {
                    blueSelect(shape1, shape2)
                } else {
                    blueNomal(shape1, shape2)
                }
            }
        },

        draw: (cfg, group) => {
            //cfg字段判断显示的单个弹窗的高度
            let container = null;
            container = (cfg.userDefShow && cfg.userDefName) ? nodeBasicMethod.createNodeBox(group, cfg, 167, 100) : nodeBasicMethod.createNodeBox(group, cfg, 167, 64);
            //标题
            group.addShape('text', {
                attrs: {
                    text: fittingString(cfg.title, 155, 13),
                    x: -70,
                    y: -15,
                    fontSize: 13,
                    textAlign: 'left',
                    textBaseline: 'middle',
                    fill: '#272931',
                    cursor: 'pointer',
                    fontWeight: 'bolder',
                },
                name: 'text1',
            });
            //单据编号四个字
            group.addShape('text', {
                attrs: {
                    text: cfg.label + ':',
                    x: -70,
                    y: 4,
                    fontSize: 12,
                    textAlign: 'left',
                    textBaseline: 'middle',
                    fill: '#8F959E',
                    cursor: 'pointer',
                },
                name: 'text2',
            });
            //编号
            group.addShape('text', {
                attrs: {
                    text: cfg.billno,
                    x: -70,
                    y: 22,
                    fontSize: 12,
                    textAlign: 'left',
                    textBaseline: 'middle',
                    fill: '#505766',
                    cursor: 'pointer',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    wordBreak: 'break-all',
                },
                name: 'text3',
            });
            //自定义值
            if (cfg.userDefShow && cfg.userDefName) {
                group.addShape('text', {
                    attrs: {
                        text: cfg.userDefName + ':',
                        x: -70,
                        y: 41,
                        fontSize: 12,
                        textAlign: 'left',
                        textBaseline: 'middle',
                        fill: '#8F959E',
                        cursor: 'pointer',

                    },
                    name: 'text4',
                });
                group.addShape('text', {
                    attrs: {
                        text: cfg.userDefShowText,
                        x: -70,
                        y: 58,
                        fontSize: 12,
                        textAlign: 'left',
                        textBaseline: 'middle',
                        fill: '#505766',
                        cursor: 'pointer',
                    },
                    name: 'text4',
                });
            }
            return container;
        },
        getAnchorPoints() {
            return [
                [0, 0.5], // 左侧中间

                [1, 0.5], // 右侧中间

            ]
        },
    }, 'rect');
}

export { renderShape }
//

export function fittingString(str, maxWidth, fontSize) {
    const ellipsis = "...";
    const ellipsisLength = G6.Util.getTextSize(ellipsis, fontSize)[0];
    let currentWidth = 0;
    let res = str;
    const pattern = new RegExp("[\u4E00-\u9FA5]+"); // distinguish the Chinese charactors and letters
    str.split("").forEach((letter, i) => {
        if (currentWidth > maxWidth - ellipsisLength) {return;}
        if (pattern.test(letter)) {
            currentWidth += fontSize;
        } else {
            currentWidth += G6.Util.getLetterWidth(letter, fontSize);
        }
        if (currentWidth > maxWidth - ellipsisLength) {
            res = `${str.substr(0, i)}${ellipsis}`;
        }
    });
    return res;
}
